import { z } from 'zod';
import { PixelEventBaseSchema } from '../pixel-event.mjs';

var _EventType = /* @__PURE__ */ ((_EventType2) => {
  _EventType2["SESSION_INIT"] = "init";
  _EventType2["SESSION_FINGERPRINT_USER_LINK"] = "fingerprint-user-link";
  _EventType2["SESSION_ATTRIBUTION"] = "attribution";
  return _EventType2;
})(_EventType || {});
var SessionEvent;
((SessionEvent2) => {
  SessionEvent2.EventType = _EventType;
  const BaseSchema = PixelEventBaseSchema.extend({
    sessionId: z.string()
  });
  SessionEvent2.SessionInitEventSchema = BaseSchema.extend({
    type: z.literal("init" /* SESSION_INIT */),
    fingerprint: z.string().nullable(),
    referrer: z.object({
      href: z.string().nullable(),
      path: z.string().nullable(),
      host: z.string().nullable()
    }).nullable()
  });
  SessionEvent2.SessionFigerprintUserLinkEventSchema = BaseSchema.extend({
    type: z.literal("fingerprint-user-link" /* SESSION_FINGERPRINT_USER_LINK */),
    fingerprint: z.string().nullable(),
    uid: z.string()
  });
  SessionEvent2.SessionAttributionEventSchema = BaseSchema.extend({
    type: z.literal("attribution" /* SESSION_ATTRIBUTION */),
    attributionId: z.string()
  });
  SessionEvent2.Validators = {
    ["init" /* SESSION_INIT */]: SessionEvent2.SessionInitEventSchema,
    ["fingerprint-user-link" /* SESSION_FINGERPRINT_USER_LINK */]: SessionEvent2.SessionFigerprintUserLinkEventSchema,
    ["attribution" /* SESSION_ATTRIBUTION */]: SessionEvent2.SessionAttributionEventSchema
  };
})(SessionEvent || (SessionEvent = {}));

export { SessionEvent, _EventType };
